import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Button } from "@material-ui/core";
import Snackbar from "../../snackbar";
import Header from "../../../partials/header";
import { styles } from "./style";
import InputFormat from "../../../partials/inputForm";
import InputImage from "../../productCategory/inputImage";
import { typeNotification } from "../../../utils/setting";
import DescriptionComponent from "../../descriptionComponent";
import Loading from "../../loading";
export class NotificationTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      template: {},
    };
  }
  async componentDidMount() {
    this.getTemplate();
  }
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.type === "checkbox") {
      value = e.target.checked ? 1 : 0;
      // value = e.target.checked;
    }
    let template = this.state.template;
    template[name] = value;
    this.setState({ template });
  };
  handleSubComponentChange = (name, value) => {
    let template = this.state.template;
    template[name] = value;
    this.setState({ template });
  };
  getInputFile = () => {
    return {
      files: this.InputImage.getFile(),
      src: this.InputImage.getSrc(),
      flagEdit: this.InputImage.getFlagEdit(),
    };
  };
  sendNotification = () => {
    let data = this.state.template;
    let { t } = this.props;
    if (!data.title || !data.description) {
      this.mSnackbar.handleClick(
        t("notification_template_please_fill_in_title_and_description")
      );
    } else {
      this.props.setNotifySending(data);
      this.props.history.push("/notification/send");
    }
  };
  getTemplate = async () => {
    this.loading.startLoading();
    let check = await this.props.getTemplate();
    this.loading.stopLoading();
    if (check.code === 1) {
      this.setState({ template: check.data || {} });
      if (check.data && check.data.content)
        this.DescriptionComponent.changeDescription(check.data.content);
    }
  };
  handleUpdateTemplate = async () => {
    let { t } = this.props;
    let { files, flagEdit } = this.getInputFile();
    let data = this.state.template;
    if (flagEdit) {
      this.loading.startLoading();
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: files,
        code: "admin",
        type: "template_notification",
      });
      data.icon = checkUpload.code === 1 ? checkUpload.data.previewLink : "";
      this.InputImage.reset();
    }
    let checkUpdate = await this.props.updateTemplate(data);
    this.loading.stopLoading();
    if (checkUpdate.code === 1) {
      this.mSnackbar.handleClick(t("notification_template_update_successful"));
      this.getTemplate();
    }
  };
  render() {
    const { t, classes, role } = this.props;
    let { template = {} } = this.state;
    return (
      <>
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={t("notification_notification")}
          title={t("notification_template")}
          backIcon={true}
          actionBack={() => this.props.history.push("/notification")}
          button={t("notification_send")}
          actionButton={() => this.sendNotification()}
        />
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("notification_type_notification")}
                value={
                  role !== "admin"
                    ? t(typeNotification.SERVICE_ALERT_NOTIFICATION)
                    : t(typeNotification.SYSTEM_NOTIFICATION)
                }
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("notification_title")}
                name="title"
                value={template.title}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputFormat
                label={t("notification_description")}
                name="description"
                value={template.description}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputImage
                onRef={(id) => (this.InputImage = id)}
                defaultImg={template.icon}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <DescriptionComponent
                onRef={(id) => (this.DescriptionComponent = id)}
                title={t("notification_content")}
                handleSubComponentChange={this.handleSubComponentChange}
                description={template.content}
                nameInput="content"
              />
            </Grid>
            <Grid item xs={12} sm={12} justify="flex-end" container={true}>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={() => this.handleUpdateTemplate()}
              >
                {t("notification_update")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({
  uploadDispatch: dispatch.upload,
  setNotifySending: dispatch.notification.setNotifySending,
  getTemplate: dispatch.templateNotification.getTemplate,
  updateTemplate: dispatch.templateNotification.update,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: 0 })(NotificationTemplate)
  )
);
